export default {
  "1": "категория 1".toUpperCase(),
  "2": "категория 2".toUpperCase(),
  "3": "категория 3".toUpperCase(),
  low: "низкосортные ресурсы".toUpperCase(),
}
